module.exports = __webpack_public_path__ + "img/butterfly.8c8add0f.svg";